import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable, OnDestroy } from '@angular/core';
import { BlahService } from '@headpower/blah-ng';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IwmLocaleService } from '../services/iwm-locale.service';

@Injectable()
export class BlahMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {

    private destroy$: Subject<void> = new Subject();

    constructor(private blahService: BlahService,
        private iwmLocaleService: IwmLocaleService) {
        super();

        this.iwmLocaleService.iwmLocale$
            .pipe(takeUntil(this.destroy$))
            .subscribe(value => this.updateTranslations());

        this.updateTranslations();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    updateTranslations() {
        this.itemsPerPageLabel = this.blahService.blah('default.paginator.itemsPerPage') + ':';
        this.nextPageLabel = this.blahService.blah('default.paginator.nextPageLabel');
        this.previousPageLabel = this.blahService.blah('default.paginator.previousPageLabel');
        this.lastPageLabel = this.blahService.blah('default.paginator.lastPageLabel');
        this.firstPageLabel = this.blahService.blah('default.paginator.firstPageLabel');

        this.changes.next(); // Notifies components that labels have changed and updates translations on the fly
    }

    override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} / ${length}`;
    }
}
